/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { PropertyResource } from '../model/models';
import { TourResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PublicServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * List of public properties
     * Filter by &#x60;type&#x60;, &#x60;status&#x60;, &#x60;userId&#x60;, &#x60;externalUserId&#x60;. Example &#x60;/properties?filter[type]&#x3D;1&#x60;
     * @param perPage 
     * @param page 
     */
    getPublicProperties(perPage?: number, page?: string, extraHttpRequestParams?: any): Observable<Array<PropertyResource>>;

    /**
     * Show public property
     * 
     * @param property The property ID
     */
    getPublicProperty(property: number, extraHttpRequestParams?: any): Observable<PropertyResource>;

    /**
     * Show public tour
     * 
     * @param tour The tour ID
     */
    getPublicTour(tour: number, extraHttpRequestParams?: any): Observable<TourResource>;

    /**
     * List of public tours
     * Filter by &#x60;type&#x60;, &#x60;status&#x60;, &#x60;userId&#x60;, &#x60;externalUserId&#x60;. Example &#x60;/tours?filter[type]&#x3D;1&#x60;
     * @param perPage 
     * @param page 
     */
    getPublicTours(perPage?: number, page?: string, extraHttpRequestParams?: any): Observable<Array<TourResource>>;

}
